<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn fab
        fixed bottom right
        color="primary"
        @click="$emit('click')"
        v-on="on"
        v-bind="attrs"
        aria-label="Scroll To Top">
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </template>
    <span>Scroll To Top</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'EsScrollToTop',
}
</script>